// 接口环境根据网管配置决定，url会固定不变，这里只需要区分以下开发环境走代理即可
export const BASE_URL = process.env.NODE_ENV === 'development' ? 'https://authority-api.hoomi.cn' : 'https://authority-api.hoomi.cn'
export const NEW_URL = process.env.NODE_ENV === 'development' ? 'https://server-test.hoomi.cn' : (process.env.NODE_ENV === 'test'?'https://server-test.hoomi.cn':'https://server-prod.hoomi.cn')
// 其他接口地址
export const OTHER_URL = 'https://api-admin.hoomi.cn'

enum HEADERCASTATE {
  DEVELOPMENT = 'test',
  TEST = 'test',
  RELEASE = 'pre',
  PRODUCTION = 'release'
}

enum DDREDIRECTURI {
  DEVELOPMENT = 'http://ding.hoomi.cn/auth',
  TEST = 'http://ding.hoomi.cn/auth',
  RELEASE = 'http://ding.hoomi.cn/auth',
  PRODUCTION = 'http://a.hoomi.cn/auth'
}

// headerxa参数
export const headerCaState = (): string => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return HEADERCASTATE.DEVELOPMENT
    case 'test':
      return HEADERCASTATE.TEST
    case 'release':
      return HEADERCASTATE.RELEASE
    case 'production':
      return HEADERCASTATE.PRODUCTION
    default:
      return ''
  }
}

// 获取钉钉重定向地址
export const ddRedirectUri = (): string => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return DDREDIRECTURI.DEVELOPMENT
    case 'test':
      return DDREDIRECTURI.TEST
    case 'release':
      return DDREDIRECTURI.RELEASE
    case 'production':
      return DDREDIRECTURI.PRODUCTION
    default:
      return ''
  }
}
